import { Table, Typography } from "antd";
import type { ColumnsType } from "antd/es/table";
import dayjs from "dayjs";
import type { TFunction } from "i18next";
import { useTranslation } from "react-i18next";
import type { JobScheduler } from "../types";

interface SchedulersTableProps {
	items: JobScheduler[];
	isLoading: boolean;
}

/**
 * ⚠️ `pattern` (cron) va `every` (interval) BIR-BIRINI ISTISNO qiladi —
 * bittasi doim `null`. Yagona «Takrorlanish» ustuni ikkalasini ham
 * ko'rsatadi; alohida `pattern` ustuni interval bilan qo'yilgan
 * schedulerni bo'sh katak qilib ko'rsatardi.
 */
function takrorlanish(t: TFunction, row: JobScheduler): string {
	if (row.pattern) {
		return row.pattern;
	}
	if (row.every !== null) {
		return t("schedulers.everyInterval", { ms: row.every });
	}

	return "—";
}

export function SchedulersTable({ items, isLoading }: SchedulersTableProps) {
	const { t } = useTranslation("jobs");

	const ustunlar: ColumnsType<JobScheduler> = [
		{ title: t("schedulers.columns.queue"), dataIndex: "queue", key: "queue" },
		{ title: t("schedulers.columns.key"), dataIndex: "key", key: "key" },
		{ title: t("schedulers.columns.job"), dataIndex: "name", key: "name" },
		{
			title: t("schedulers.columns.pattern"),
			key: "pattern",
			render: (_, row) => takrorlanish(t, row),
		},
		{
			title: t("schedulers.columns.tz"),
			key: "tz",
			/**
			 * ⚠️ **Bu ustun MUHIM:** `settings.timezone` o'zgartirilganda
			 * schedulerlar `syncXScheduler()` bilan qayta yozilishi kerak
			 * (`upsertShiftGenerationScheduler()` zonani BIR MARTA o'qiydi).
			 * Sinxronlanmagan scheduler boshqa hech qayerda ko'rinmasdi.
			 */
			render: (_, row) => row.tz ?? "—",
		},
		{
			title: t("schedulers.columns.next"),
			key: "next",
			render: (_, row) => (row.next ? dayjs(row.next).format("DD.MM.YYYY HH:mm") : "—"),
		},
	];

	return (
		<>
			<Typography.Paragraph type="secondary">{t("schedulers.hint")}</Typography.Paragraph>
			<Table<JobScheduler>
				columns={ustunlar}
				dataSource={items}
				rowKey="key"
				loading={isLoading}
				size="small"
				pagination={false}
				scroll={{ x: "max-content" }}
			/>
		</>
	);
}
